import React from 'react';

// Composant InterfaceSection déplacé à l'extérieur pour éviter les re-renders
const InterfaceSection = React.memo(({ env, title, bgColor, data, addInterface, updateInterface, removeInterface }) => {
  const entrants = data[env]?.filter(i => i.direction === 'IN') || [];
  const sortants = data[env]?.filter(i => i.direction === 'OUT') || [];

  return (
    <div className={`border border-gray-200 rounded-lg p-6 ${bgColor}`}>
      <h3 className="text-lg font-semibold mb-4">{title}</h3>
      
      {/* Flux entrants */}
      <div className="mb-8">
        <div className="flex justify-between items-center mb-4">
          <h4 className="font-medium text-gray-700">Flux entrants (vers Engage)</h4>
          <button
            onClick={() => addInterface(env, 'IN')}
            className="px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 transition-colors"
          >
            + Ajouter flux entrant
          </button>
        </div>
        
        {entrants.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="w-full border-collapse text-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 px-2 py-1 text-left">Module</th>
                  <th className="border border-gray-300 px-2 py-1 text-left">ID Flux</th>
                  <th className="border border-gray-300 px-2 py-1 text-left">Description</th>
                  <th className="border border-gray-300 px-2 py-1 text-left">Type</th>
                  <th className="border border-gray-300 px-2 py-1 text-left">Protocole</th>
                  <th className="border border-gray-300 px-2 py-1 text-left">Source</th>
                  <th className="border border-gray-300 px-2 py-1 text-left">Cible</th>
                  <th className="border border-gray-300 px-2 py-1 text-left">Statut</th>
                  <th className="border border-gray-300 px-2 py-1 text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {entrants.map((flux, index) => {
                  const realIndex = data[env].findIndex(i => i.id === flux.id);
                  return (
                    <tr key={flux.id}>
                      <td className="border border-gray-300 px-2 py-1">
                        <input
                          type="text"
                          value={flux.module || ''}
                          onChange={(e) => updateInterface(env, realIndex, 'module', e.target.value)}
                          className="w-full px-1 py-0.5 border border-gray-300 rounded text-sm"
                          placeholder="Ex: Suivi connecté"
                        />
                      </td>
                      <td className="border border-gray-300 px-2 py-1">
                        <input
                          type="text"
                          value={flux.idFlux || ''}
                          onChange={(e) => updateInterface(env, realIndex, 'idFlux', e.target.value)}
                          className="w-20 px-1 py-0.5 border border-gray-300 rounded text-sm"
                          placeholder="IN_1"
                        />
                      </td>
                      <td className="border border-gray-300 px-2 py-1">
                        <input
                          type="text"
                          value={flux.description || ''}
                          onChange={(e) => updateInterface(env, realIndex, 'description', e.target.value)}
                          className="w-full px-1 py-0.5 border border-gray-300 rounded text-sm"
                          placeholder="ADT IN"
                        />
                      </td>
                      <td className="border border-gray-300 px-2 py-1">
                        <input
                          type="text"
                          value={flux.typeFlux || ''}
                          onChange={(e) => updateInterface(env, realIndex, 'typeFlux', e.target.value)}
                          className="w-20 px-1 py-0.5 border border-gray-300 rounded text-sm"
                          placeholder="HL7"
                        />
                      </td>
                      <td className="border border-gray-300 px-2 py-1">
                        <input
                          type="text"
                          value={flux.protocole || ''}
                          onChange={(e) => updateInterface(env, realIndex, 'protocole', e.target.value)}
                          className="w-20 px-1 py-0.5 border border-gray-300 rounded text-sm"
                          placeholder="SFTP"
                        />
                      </td>
                      <td className="border border-gray-300 px-2 py-1">
                        <input
                          type="text"
                          value={flux.serveurSource || ''}
                          onChange={(e) => updateInterface(env, realIndex, 'serveurSource', e.target.value)}
                          className="w-24 px-1 py-0.5 border border-gray-300 rounded text-sm"
                          placeholder="Serveur"
                        />
                      </td>
                      <td className="border border-gray-300 px-2 py-1">
                        <input
                          type="text"
                          value={flux.serveurCible || ''}
                          onChange={(e) => updateInterface(env, realIndex, 'serveurCible', e.target.value)}
                          className="w-24 px-1 py-0.5 border border-gray-300 rounded text-sm"
                          placeholder="Exolis"
                        />
                      </td>
                      <td className="border border-gray-300 px-2 py-1">
                        <select
                          value={flux.statut || 'Non configuré'}
                          onChange={(e) => updateInterface(env, realIndex, 'statut', e.target.value)}
                          className={`w-full px-1 py-0.5 border rounded text-sm ${
                            flux.statut === 'Actif' ? 'bg-green-100 border-green-300' :
                            flux.statut === 'En test' ? 'bg-yellow-100 border-yellow-300' :
                            'bg-gray-100 border-gray-300'
                          }`}
                        >
                          <option value="Non configuré">Non configuré</option>
                          <option value="En test">En test</option>
                          <option value="Actif">Actif</option>
                          <option value="Inactif">Inactif</option>
                        </select>
                      </td>
                      <td className="border border-gray-300 px-2 py-1 text-center">
                        <button
                          onClick={() => removeInterface(env, realIndex)}
                          className="text-red-600 hover:text-red-800"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-sm text-gray-500 text-center py-4 bg-gray-50 rounded">
            Aucun flux entrant configuré
          </p>
        )}
      </div>

      {/* Flux sortants */}
      <div>
        <div className="flex justify-between items-center mb-4">
          <h4 className="font-medium text-gray-700">Flux sortants (vers Établissement)</h4>
          <button
            onClick={() => addInterface(env, 'OUT')}
            className="px-3 py-1 bg-green-600 text-white text-sm rounded hover:bg-green-700 transition-colors"
          >
            + Ajouter flux sortant
          </button>
        </div>
        
        {sortants.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="w-full border-collapse text-sm">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 px-2 py-1 text-left">Module</th>
                  <th className="border border-gray-300 px-2 py-1 text-left">ID Flux</th>
                  <th className="border border-gray-300 px-2 py-1 text-left">Description</th>
                  <th className="border border-gray-300 px-2 py-1 text-left">Type</th>
                  <th className="border border-gray-300 px-2 py-1 text-left">Protocole</th>
                  <th className="border border-gray-300 px-2 py-1 text-left">Source</th>
                  <th className="border border-gray-300 px-2 py-1 text-left">Cible</th>
                  <th className="border border-gray-300 px-2 py-1 text-left">Statut</th>
                  <th className="border border-gray-300 px-2 py-1 text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {sortants.map((flux, index) => {
                  const realIndex = data[env].findIndex(i => i.id === flux.id);
                  return (
                    <tr key={flux.id}>
                      <td className="border border-gray-300 px-2 py-1">
                        <input
                          type="text"
                          value={flux.module || ''}
                          onChange={(e) => updateInterface(env, realIndex, 'module', e.target.value)}
                          className="w-full px-1 py-0.5 border border-gray-300 rounded text-sm"
                          placeholder="Ex: Préadmission"
                        />
                      </td>
                      <td className="border border-gray-300 px-2 py-1">
                        <input
                          type="text"
                          value={flux.idFlux || ''}
                          onChange={(e) => updateInterface(env, realIndex, 'idFlux', e.target.value)}
                          className="w-20 px-1 py-0.5 border border-gray-300 rounded text-sm"
                          placeholder="OUT_1"
                        />
                      </td>
                      <td className="border border-gray-300 px-2 py-1">
                        <input
                          type="text"
                          value={flux.description || ''}
                          onChange={(e) => updateInterface(env, realIndex, 'description', e.target.value)}
                          className="w-full px-1 py-0.5 border border-gray-300 rounded text-sm"
                          placeholder="ADT OUT"
                        />
                      </td>
                      <td className="border border-gray-300 px-2 py-1">
                        <input
                          type="text"
                          value={flux.typeFlux || ''}
                          onChange={(e) => updateInterface(env, realIndex, 'typeFlux', e.target.value)}
                          className="w-20 px-1 py-0.5 border border-gray-300 rounded text-sm"
                          placeholder="HL7"
                        />
                      </td>
                      <td className="border border-gray-300 px-2 py-1">
                        <input
                          type="text"
                          value={flux.protocole || ''}
                          onChange={(e) => updateInterface(env, realIndex, 'protocole', e.target.value)}
                          className="w-20 px-1 py-0.5 border border-gray-300 rounded text-sm"
                          placeholder="SFTP"
                        />
                      </td>
                      <td className="border border-gray-300 px-2 py-1">
                        <input
                          type="text"
                          value={flux.serveurSource || ''}
                          onChange={(e) => updateInterface(env, realIndex, 'serveurSource', e.target.value)}
                          className="w-24 px-1 py-0.5 border border-gray-300 rounded text-sm"
                          placeholder="Exolis"
                        />
                      </td>
                      <td className="border border-gray-300 px-2 py-1">
                        <input
                          type="text"
                          value={flux.serveurCible || ''}
                          onChange={(e) => updateInterface(env, realIndex, 'serveurCible', e.target.value)}
                          className="w-24 px-1 py-0.5 border border-gray-300 rounded text-sm"
                          placeholder="SIH"
                        />
                      </td>
                      <td className="border border-gray-300 px-2 py-1">
                        <select
                          value={flux.statut || 'Non configuré'}
                          onChange={(e) => updateInterface(env, realIndex, 'statut', e.target.value)}
                          className={`w-full px-1 py-0.5 border rounded text-sm ${
                            flux.statut === 'Actif' ? 'bg-green-100 border-green-300' :
                            flux.statut === 'En test' ? 'bg-yellow-100 border-yellow-300' :
                            'bg-gray-100 border-gray-300'
                          }`}
                        >
                          <option value="Non configuré">Non configuré</option>
                          <option value="En test">En test</option>
                          <option value="Actif">Actif</option>
                          <option value="Inactif">Inactif</option>
                        </select>
                      </td>
                      <td className="border border-gray-300 px-2 py-1 text-center">
                        <button
                          onClick={() => removeInterface(env, realIndex)}
                          className="text-red-600 hover:text-red-800"
                        >
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-sm text-gray-500 text-center py-4 bg-gray-50 rounded">
            Aucun flux sortant configuré
          </p>
        )}
      </div>
    </div>
  );
});

export const InterfacesTab = ({ data, setData }) => {
  const addInterface = React.useCallback((env, direction) => {
    const newInterface = {
      id: Date.now(),
      module: '',
      idFlux: '',
      description: '',
      typeFlux: '',
      logiciel: '',
      serveurSource: '',
      ipSource: '',
      protocole: '',
      serveurCible: '',
      ipCible: '',
      port: '',
      login: '',
      repertoire: '',
      semaphore: '',
      commentaire: '',
      ajustementsEAI: '',
      ajustementConnecteur: '',
      statut: 'Non configuré'
    };

    setData(prev => ({
      ...prev,
      interfaces: {
        ...prev.interfaces,
        [env]: [...(prev.interfaces?.[env] || []), { ...newInterface, direction }]
      }
    }));
  }, [setData]);

  const updateInterface = React.useCallback((env, index, field, value) => {
    setData(prev => {
      const updatedInterfaces = [...(prev.interfaces?.[env] || [])];
      updatedInterfaces[index] = {
        ...updatedInterfaces[index],
        [field]: value
      };
      return {
        ...prev,
        interfaces: {
          ...prev.interfaces,
          [env]: updatedInterfaces
        }
      };
    });
  }, [setData]);

  const removeInterface = React.useCallback((env, index) => {
    setData(prev => ({
      ...prev,
      interfaces: {
        ...prev.interfaces,
        [env]: (prev.interfaces?.[env] || []).filter((_, i) => i !== index)
      }
    }));
  }, [setData]);

  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Matrice des flux / Interopérabilité</h2>
      
      {/* Production */}
      <InterfaceSection 
        env="production" 
        title="Interfaces PRODUCTION" 
        bgColor="bg-red-50"
        data={data}
        addInterface={addInterface}
        updateInterface={updateInterface}
        removeInterface={removeInterface}
      />

      {/* Qualification */}
      <InterfaceSection 
        env="qualification" 
        title="Interfaces QUALIFICATION" 
        bgColor="bg-blue-50"
        data={data}
        addInterface={addInterface}
        updateInterface={updateInterface}
        removeInterface={removeInterface}
      />

      {/* Informations types de flux */}
      <div className="mt-8 bg-gray-50 rounded-lg p-6 border border-gray-200">
        <h4 className="font-semibold text-gray-800 mb-3">Types de flux courants :</h4>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm text-gray-600">
          <div>
            <h5 className="font-medium text-gray-700">ADT</h5>
            <p>Admission, Discharge, Transfer</p>
          </div>
          <div>
            <h5 className="font-medium text-gray-700">SIU</h5>
            <p>Scheduling Information Unsolicited</p>
          </div>
          <div>
            <h5 className="font-medium text-gray-700">ORM</h5>
            <p>Order Message</p>
          </div>
          <div>
            <h5 className="font-medium text-gray-700">ORU</h5>
            <p>Observation Result</p>
          </div>
        </div>
      </div>
    </div>
  );
};